import React from 'react';
import { Query } from 'react-apollo';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getStaticMessage } from '../../graphql/queries/staticMessage';
import Header from '../common/Header';

const StaticMessage = () => {
  let { id } = useParams();
  const { t } = useTranslation();

  return (
    <div className="list">
      <Header
        title="staticMessages.show.title"
        linkTo={`/admin/static_messages/${id}/edit`}
        buttonLabel="shared.edit"
      />
      <Query {...getStaticMessage(id)}>
        {({ loading, data }) => {
          if (loading) return <div className="lds-dual-ring" />;
          if (data) {
            const { staticMessage } = data;

            return (
              <div className="common-show">
                <div className="grid">
                  <div className="col-12">
                    <div className="common-show__infos">
                      <div className="col-12">
                        <div className="common-show__infos--field">
                          {t('staticMessages.attributes.key')}
                        </div>
                        <div className="common-show__infos--value">{staticMessage.key}</div>
                        <div className="common-show__infos--field">
                          {t('staticMessages.attributes.message')}
                        </div>
                        <div className="common-show__infos--value">{staticMessage.message}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
          return null;
        }}
      </Query>
    </div>
  );
};

export default StaticMessage;
